import { render, staticRenderFns } from "./extended-preferences-section.vue?vue&type=template&id=63e1b74c"
import script from "./extended-preferences-section.vue?vue&type=script&lang=js"
export * from "./extended-preferences-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports